import React from 'react';
import dayjs from 'dayjs';

import { weeklyPlannerDayDisplayFormat } from '~libs/dayjs';

interface DayDisplayProps {
  date: string;
}

const DayDisplay: React.FC<DayDisplayProps> = ({ date }) => {
  const formattedDate = dayjs(date);
  if (!formattedDate.isValid()) {
    return <div>-</div>;
  }
  return <div>{formattedDate.format(weeklyPlannerDayDisplayFormat)}</div>;
};

export default DayDisplay;
